// extracted by mini-css-extract-plugin
export var actionIcon = "_qv-0";